<template>
  <div class="org-index">
    <div
      v-if="!orgDatasReady"
      class="loading"
    >
      <cube-loading :size="40" />
    </div>
    <div v-else>
      <full-tips />
      <div class="user-account">
        <router-link
          :to="{name: 'AccountInfo'}"
          class="account-tit"
        >
          <i class="icon iconfont iconicon-test44" />
          {{ userName }}
        </router-link>
        <span class="m-org-r">
          <!-- <i
            class="icon-new-year"
            @click="showSpringDialog"
          /> -->
          <i
            v-if="isNewFeature"
            class="iconfont iconnew new-feature-icon"
            @click="getNewFeatureDialog"
          />
        </span>
      </div>
      <org-item
        v-for="(item,index) in orgDatas"
        :key="index"
        :org-item-data="item"
        :mobile="mobile"
      />
      <div
        v-if="!$isDingDing"
        class="create-box"
      >
        <cube-button
          :light="true"
          @click="creatOrg"
        >
          {{ $t('message["129"]') }}
        </cube-button>
      </div>
      <new-feature ref="newFeatureDialog" />
    </div>
    <!-- <spring-pop ref="showPop" /> -->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import FullTips from '@/components/mobile/FullTips'
import OrgItem from './OrgItem'
import NewFeature from './NewFeature'
// import SpringPop from './SpringPop'
// import Cookies from 'js-cookie'
export default {
  components: {
    FullTips,
    OrgItem,
    NewFeature
    // SpringPop
  },
  data () {
    return {
      userName: '',
      mobile: '',
      cookie: ''
    }
  },
  computed: {
    ...mapState('organization/org', ['orgDatasReady', 'orgDatas']),
    ...mapState('newFeature', ['newFeatureInfo']),
    ...mapState(['baseinfo']),
    isNewFeature () {
      return this.baseinfo.announce
    }
  },
  async mounted () {
    const chain = await this.fetchOrgDatas()
    chain
      .onSuccess((data, res) => {
        this.userName = res.baseinfo.truename
        this.mobile = res.baseinfo.mobile
        // this.cookie = Cookies.get('old')
        // if (!this.cookie) {
        //   this.$refs.showPop.showPopup()
        //   Cookies.set('old', this.$store.state.auth, { expires: 30 })
        // }
      })
      .fetch()
  },
  methods: {
    ...mapActions('organization/org', ['fetchOrgDatas']),
    ...mapActions('newFeature', ['getNewFeatureInfo']),
    creatOrg () {
      this.$router.push({ name: 'OrgIndex', query: { page: 4 } })
    },
    async getNewFeatureDialog () {
      const { newFeatureInfo } = this
      if (newFeatureInfo) {
        // this.showNewFeatureDialog(newFeatureInfo)
        this.$refs.newFeatureDialog.showDialog()
      } else {
        const chain = await this.getNewFeatureInfo()
        chain.onSuccess(raw => {
          // this.showNewFeatureDialog(raw.content)
          this.$refs.newFeatureDialog.showDialog()
        })
      }
    }
    // showSpringDialog () {
    //   this.$refs.showPop.showPopup()
    // }

  }
}
</script>
<style lang="scss" scoped>
.org-index::v-deep{
  .user-account {
    display: flex;
    justify-content: space-between;
    color: #979797;
    font-size: 14px;
    padding: 8px 12px 20px 28px;
    line-height: 24px;
    a {
      color: #4E76AC;
    }
    .iconicon-test44 {
      font-size: 20px;
      margin-right: 8px;
      color: $primary-color;
      vertical-align: middle;
      color: #d6d6d6;
    }
    .new-feature-icon {
      color: #4CA0F2;
      font-size: 20px;
      vertical-align: middle;
      // margin-right: 16px;
    }
  }
  .create-box {
    margin: 0 12px;
  }
  .icon-new-year {
     width: 24px;
    height: 24px;
    background:url(../../assets/images/newyearico.png) no-repeat 0 0;
    background-size: 24px 24px;
    display:inline-block;
    // margin-left: 4px;
    //margin-top: -4px;
    margin-right: 6px;
    vertical-align: middle;
  }
}
</style>
